import { connect } from "react-redux";
import InvoiceRequestList from "./invoiceRequestList";
import { bindActionCreators } from "redux";
import { getInvoiceRequestList,getListFilterData } from "services/redux/sales/vendorPortal/action";

import {
  fetchZones
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  invoiceRequestList: state.vendorPortalReducer.invoiceRequestList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.vendorPortalReducer.list_filter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getInvoiceRequestList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceRequestList);
